import React from "react";
import DataService from "services/DataService";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
// import Paper from "@material-ui/core/Paper";
import constants from "../../constants/User/user";
import { useUser } from "../../context/userContext";
import { useAlert } from "../../context/Feedback/alertContext";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/material-dashboard-react/components/dialogHowToUse";
import "./classes.css";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
// import CheckIcon from "@material-ui/icons/Check";
// import { TextField } from "@material-ui/core";
// const percent = "100%";
import "./userDialog.css";
const useStyles = makeStyles(styles);

export default function ChangePasswordDialog() {
  const {
    isActiveChangePasswordDialog,
    setActiveChangePasswordDialog,
    language,
    credential,
    user,
  } = useUser();

  const { setAlert } = useAlert();
  const [checked, setChecked] = useState(true);
  const [lastPassword, setLastPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  //   const [spacing] = React.useState(2);
  const classes = useStyles();

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleCancel = () => {
    setActiveChangePasswordDialog(false);
  };

  const updatePassword = async () => {
    const authorization = {
      headers: {
        Authorization: credential,
      },
    };
    try {
      await DataService.changePass(
        user.email,
        lastPassword,
        newPassword,
        authorization
      );

      setAlert({
        active: true,
        text: constants.alerts.attPasswordSucceed[language],
        color: "success",
        sevarity: "info",
        // icon: ErrorIcon,
      });
      setNewPassword("");
      setLastPassword("");
    } catch (e) {
      console.log(e);
      setAlert({
        active: true,
        text: constants.alerts.attPasswordFail[language],
        color: "danger",
        sevarity: "info",
        // icon: ErrorIcon,
      });
      setNewPassword("");
      setLastPassword("");
    }
  };

  return (
    <div>
      <Dialog
        checked={checked}
        onChange={handleChange}
        open={isActiveChangePasswordDialog}
        keepMounted
        onClose={handleCancel}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.dialog} id="alert-dialog-slide-title">
          <div className="wrapper-title">
            {constants.modal.changePassword[language]}
            <div className="wrapper-button-close">
              <Button onClick={handleCancel}>X</Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <Grid container justifyContent="center">
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader>
                  <h4 className={classes.cardTitleWhite}>
                    {constants.modal.changePassword[language]}
                  </h4>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText={constants.user.lastPassword[language]}
                        onChange={(e) => {
                          setLastPassword(e.target.value);
                        }}
                        id="first-name"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "password",
                          required: true,
                          value: lastPassword,
                        }}
                        // inputProps={{
                        //   value: firstname,
                        // }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText={constants.user.newPassword[language]}
                        onChange={(e) => {
                          setNewPassword(e.target.value);
                        }}
                        id="last-name"
                        formControlProps={{
                          fullWidth: true,
                          // disabled: true,
                        }}
                        inputProps={{
                          type: "password",
                          required: true,
                          value: newPassword,
                        }}
                        // inputProps={{
                        //   value: lastname,
                        // }}
                      />
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <Button
                    color="success"
                    onClick={() => {
                      updatePassword();
                    }}
                  >
                    {constants.user.attPassword[language]}
                  </Button>
                  <Button
                    color="danger"
                    onClick={() => {
                      handleCancel();
                    }}
                  >
                    {constants.user.cancel[language]}
                  </Button>
                </CardFooter>
              </Card>
            </GridItem>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialog}></DialogActions>
      </Dialog>
    </div>
  );
}
